const AMSTERDAM_TIME_ZONE = 'Europe/Amsterdam';
const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

const calendarDateFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: AMSTERDAM_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
});

export function formatAmsterdamCalendarDate(value: string): string {
    const match = DATE_ONLY_PATTERN.exec(value);
    const date = match
        ? new Date(`${value}T12:00:00.000Z`)
        : new Date(value);

    if (Number.isNaN(date.getTime())) return value;
    if (match && date.toISOString().slice(0, 10) !== value) return value;
    return calendarDateFormatter.format(date);
}
